import { type OnDemandItem } from "@ca.vmedia.tv/domains";
import { CardDataType, type ImageCardData, type PlayCardData, ComponentName } from "../types";

export class RelatedOnDemandCardData implements ImageCardData, PlayCardData {

    private item: OnDemandItem;
    private postfixId: string;

    constructor(item: OnDemandItem, postfixId: string = '0') {
        this.item = item;
        this.postfixId = postfixId;
    }

    getId(): string {
        return `${this.item.id}_${this.postfixId}`;
    }

    getImage(): string {
        return this.item.image ?? '';
    }
    
    getPlayItem(): OnDemandItem {
        return this.item;
    }

    getClass(): string {
        return 'ondemand-card';
    }

    getType(): CardDataType {
        return CardDataType.OnDemand;
    }

    getContentType(): string {
        return `${this.item.contentType}`;
    }

    getComponentName(): ComponentName {
        return ComponentName.MOVIE;
    }

    getName(): string {
        if (this.isNotEmpty(this.item.seriesName)) {
            return this.item.seriesName!;
        }
        if (this.isNotEmpty(this.item.shortName)) {
            return this.item.shortName!;
        }
        if (this.isNotEmpty(this.item.name)) {
            return this.item.name!;
        }
        return "";
    }

    isNotEmpty(val: string | null): boolean {
        return (val != null && val.length > 0);
    }
}
